import { useQuery } from '@tanstack/react-query';
import { getAllTemplatesByCommand } from '../api/email-service';
import { IDomainCommandType } from '@publishing-engine/domain/actions/v1/commands';
import { EmailTemplateDoc } from '@publishing-engine/domain/models/email-templates';

interface UseCommandEmailTemplatesParams {
  organizationId: string;
  commandName: IDomainCommandType;
  query?: {
    subtype?: string;
    action?: string;
    tag?: string;
  };
}

interface UseCommandEmailTemplatesResult {
  hasCustomizableTemplates: boolean;
  isLoading: boolean;
  templates: EmailTemplateDoc[];
}

export function useCommandEmailTemplates({
  organizationId,
  commandName,
  query
}: UseCommandEmailTemplatesParams): UseCommandEmailTemplatesResult {
  const { data, isLoading } = useQuery({
    queryKey: ['emailTemplates', organizationId, commandName, query?.subtype],
    queryFn: () =>
      getAllTemplatesByCommand({
        organizationId,
        commandName,
        query
      })
  });

  const customizableTemplates =
    data?.data?.filter(template => template.customizable) ?? [];

  return {
    hasCustomizableTemplates: customizableTemplates.length > 0,
    templates: customizableTemplates ?? [],
    isLoading
  };
}
